<template>
  <div class="form">
    <div v-if="showtip" class="body-right-set-tip max-width flex-row-align-center">
      <p class="font-size-12">完善个人信息后，更容易找到组织，发布馆藏时更容易过审哦！</p>
      <p class="font-size-12 cursor" @click="showtip = false">x</p>
    </div>

    <div v-if="status==0 && user" class="body-right-set-form">
      <div class="body-right-set-form-padding">
        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-16 font-color-FA5E5F body-right-set-form-item-key-must">*</p>
            <p class="font-size-14 font-color-1F233E font-bold">昵称</p>
          </div>
          <div class="body-right-set-form-item-value flex-row-align-center">
            <el-input v-model="user.name" class="font-color-264480 font-size-12" :maxlength="30" placeholder="起个好听的名字吧~！" />
          </div>
        </div>

        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">用户ID</p>
          </div>
          <div class="body-right-set-form-item-value input-disabel flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">{{ user.userId }}</p>
          </div>
          <div class="body-right-set-form-item-des flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">你唯一的标识</p>
          </div>
        </div>
        <!-- 真实姓名 -->
        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">真实姓名</p>
          </div>
          <div class="body-right-set-form-item-value flex-row-align-center">
            <el-input v-model="user.realName" class="font-color-264480 font-size-12" :maxlength="30" placeholder="请输入真实姓名" />
          </div>
        </div>

        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">性别</p>
          </div>
          <div class="body-right-set-form-item-value select flex-row-align-center flex-row-justify-space-between position-relative">
            <el-select v-model="sexKey" class=" flex-1" placeholder="请选择">
              <el-option
                v-for="item in sexlist"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              />
            </el-select>
            <img class="end-arrow position-absolute" :class="sexSel?'end-arrow-transform':''" src="../../../../../assets/icon-lib-drop-arrow.png" alt="">
          </div>
        </div>
        <!-- 出生日期 -->
        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">出生日期</p>
          </div>
          <div class="body-right-set-form-item-value flex-row-align-center flex-row-justify-space-between date position-relative">
            <el-date-picker
              v-model="user.bornDay"
              class=" flex-1"
              name="bornDay"
              value-format="yyyy-MM-dd"
              type="date"
              size="normal"
              :clearable="false"
              :editable="false"
              placeholder="请选择出生日期"
              @change="datechange"
              @focus="datefocus"
            />
            <img class="end-arrow position-absolute" src="../../../../../assets/icon-lib-drop-arrow.png" alt="">
          </div>
        </div>
      </div>
      <div class="body-right-set-action mach-width flex-center">
        <div class="body-right-set-action-btns flex-row-align-center">
          <div class="flex-center body-right-set-action-btns-save radius-clip-5 bg-282B80 cursor" @click="requestSave">
            <p class="font-size-14 font-color-white">保存</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="status == 1" class="body-right-set-form">
      <div class="body-right-set-form-padding">
        <div class="body-right-set-form-item flex">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">头像</p>
          </div>
          <div class="body-right-set-form-item-value-cropper">
            <cropper ref="cropperimg" @success="uploadSuccess" />
          </div>
        </div>
      </div>
      <div class="body-right-set-action mach-width flex-center">
        <div class="body-right-set-action-btns flex-row-align-center">
          <div class="flex-center body-right-set-action-btns-save radius-clip-5 bg-282B80 cursor" @click="requestSave">
            <p class="font-size-14 font-color-white">保存</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="status==2 && school" class="body-right-set-form">
      <div class="body-right-set-form-padding">
        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <!-- <p class="font-size-16 font-color-FA5E5F body-right-set-form-item-key-must">*</p> -->
            <p class="font-size-14 font-color-1F233E font-bold">我现在是</p>
          </div>
          <div class="body-right-set-form-item-value flex-row-align-center flex-row-justify-space-between position-relative">
            <el-select v-model="currentmajor" class=" flex-1" placeholder="请选择" :popper-append-to-body="false" @change="majorselectchange">
              <el-option
                v-for="item in majoroptions"
                :key="item.dictValue"
                :label="item.dictValue"
                :value="item.dictKey"
              />
            </el-select>
            <img class="position-absolute end-arrow" src="../../../../../assets/icon-lib-drop-arrow.png" alt="">
          </div>
        </div>

        <div v-for="(item, idx) in forms" :key="idx" class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <!-- <p v-if="item.must" class="font-size-16 font-color-FA5E5F body-right-set-form-item-key-must">*</p> -->
            <p class="font-size-14 font-color-1F233E font-bold">{{ item.label }}</p>
          </div>
          <div class="body-right-set-form-item-value flex-row-align-center flex-row-justify-space-between position-relative">
            <el-input v-if="item.type == 'input'" v-model="school[item.key]" class="font-color-264480 font-size-12" :maxlength="item.key=='schoolTutor'?8:30" placeholder="请输入" />
            <el-select v-else-if="item.type=='select'" v-model="currentprofession" class=" flex-1" placeholder="请选择" :popper-append-to-body="false">
              <el-option
                v-for="s in professionals"
                :key="s.dictValue"
                :label="s.dictValue"
                :value="s.dictValue"
              />
            </el-select>
            <el-date-picker
              v-else-if="item.type == 'date'"
              v-model="school[item.key]"
              :name="item.key"
              value-format="yyyy"
              type="year"
              size="normal"
              data-id="date"
              :editable="false"
              :clearable="false"
              placeholder="请选择日期"
              class="flex-1"
              @change="datechange"
              @focus="datefocus"
            />
            <img v-if="item.type == 'date' || item.type== 'select'" class="position-absolute end-arrow" src="../../../../../assets/icon-lib-drop-arrow.png" alt="">

          </div>
        </div>
      </div>

      <div class="body-right-set-action mach-width flex-center">
        <div class="body-right-set-action-btns flex-row-align-center">
          <div class="flex-center body-right-set-action-btns-save radius-clip-5 bg-282B80 cursor" @click="requestSave">
            <p class="font-size-14 font-color-white">保存</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="status==3" class="body-right-set-form">
      <div class="body-right-set-form-padding">
        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">账号认证</p>
          </div>
          <div class="body-right-set-form-item-btn flex-center bg-282B80 radius-clip-5">
            <p v-if="userInfo.authentication" class="font-color-white font-size-14 flex-center">已认证</p>
            <p v-else class="font-color-white font-size-14 flex-center" @click="toAuth">去认证</p>
          </div>
        </div>

        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">绑定手机</p>
          </div>
          <div class="body-right-set-form-item-value input-disabel flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">{{ userInfo.phone }}</p>
          </div>

          <div class="body-right-set-form-item-des flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">修改绑定手机号可联系客服</p>
          </div>
        </div>

        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">绑定微信</p>
          </div>
          <div class="body-right-set-form-item-btn flex-center bg-18B718 radius-clip-5">
            <p v-if="userInfo.wxOpenid.length" class="font-color-white font-size-14 flex-center">已绑定</p>
            <p v-else class="font-color-white font-size-14 flex-center cursor" @click="bindWx">去绑定</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import cropper from './cropperImage.vue'
import api from '../../../../../api/userpage.js'
import comapi from '../../../../../api/common.js'
import userdata from '../../../../../models/user.js'
import config from '../../../../../utils/config.js'
const Base64 = require('js-base64').Base64
export default {
  components: {
    cropper
  },
  props: {
    status: {
      type: String,
      default: '0',
      required: true
    }
  },
  data() {
    return {
      option: {
        img: '', // 裁剪图片的地址
        outputSize: 1, // 裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg', // 裁剪生成图片的格式（jpeg || png || webp）
        info: true, // 图片大小信息
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 300, // 默认生成截图框宽度
        autoCropHeight: 300, // 默认生成截图框高度
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1, 1], // 截图框的宽高比例
        full: false, // false按原比例裁切图片，不失真
        fixedBox: false, // 固定截图框大小，不允许改变
        canMove: true, // 上传图片是否可以移动
        canMoveBox: false, // 截图框能否拖动
        original: true, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        height: true, // 是否按照设备的dpr 输出等比例图片
        infoTrue: false, // true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000, // 限制图片最大宽度和高度
        enlarge: 1, // 图片根据截图框输出比例倍数
        mode: '300px 300px' // 图片默认渲染方式
      },
      form: {},
      user: null,
      userInfo: null,
      showtip: true,
      sexlist: null,
      sexKey: '',

      school: null,
      currentmajor: 2,
      currentcls: '',
      majoroptions: [{
        key: 'junior',
        label: '专科',
        value: 'junior',
        id: 0,
        cls: 'junior'
      }, {
        key: 'undergraduate',
        label: '本科',
        value: 'undergraduate',
        id: 1,
        cls: 'junior'
      }, {
        key: 'master',
        label: '硕士',
        value: 'master',
        id: 0,
        cls: 'master'
      }, {
        key: 'doctor',
        label: '博士',
        value: 'doctor',
        id: 0,
        cls: 'master'
      }, {
        key: 'postdoctor',
        label: '博士后',
        value: 'postdoctor',
        id: 0,
        cls: 'master'
      }, {
        key: 'classmate',
        label: '校友',
        value: 'classmate',
        id: 0,
        cls: 'classmate'
      }, {
        key: 'teacher',
        label: '老师',
        value: 'teacher',
        id: 0,
        cls: 'teacher'
      }],
      forms: [],
      majorforms: {
        junior: [{
          type: 'input',
          value: '',
          key: 'schoolName',
          label: '所在学校',
          must: false
        }, {
          type: 'date',
          value: '',
          key: 'schoolAddTime',
          label: '入学年份',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDepartment',
          label: '学部',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDeptName',
          label: '学院',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolMajor',
          label: '专业',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolClass',
          label: '班级',
          must: false
        }],
        master: [{
          type: 'input',
          value: '',
          key: 'schoolName',
          label: '所在学校',
          must: false
        }, {
          type: 'date',
          value: '',
          key: 'schoolAddTime',
          label: '入学年份',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDepartment',
          label: '学部',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDeptName',
          label: '学院',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolMajor',
          label: '专业',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolClass',
          label: '班级',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolTutor',
          label: '导师',
          must: false
        }],
        classmate: [{
          type: 'input',
          value: '',
          key: 'schoolName',
          label: '所在学校',
          must: true
        }, {
          type: 'date',
          value: '',
          key: 'schoolAddTime',
          label: '入学年份',
          must: false
        }, {
          // TODO:毕业年份没有找到对应字段
          type: 'date',
          value: '',
          key: 'schoolLeaveTime',
          label: '毕业年份',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDepartment',
          label: '学部',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDeptName',
          label: '学院',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolMajor',
          label: '专业',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolClass',
          label: '班级',
          must: false
        }],
        teacher: [{
          type: 'input',
          value: '',
          key: 'schoolName',
          label: '所在学校',
          must: true
        }, {
          type: 'date',
          value: '',
          key: 'schoolWorkTime',
          label: '入职年份',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDepartment',
          label: '学部',
          must: false
        }, {
          type: 'input',
          value: '',
          key: 'schoolDeptName',
          label: '学院',
          must: false
        }, {
          // TODO:职称没有找到对应字段
          type: 'select',
          value: '',
          key: 'schoolTitle',
          label: '职称',
          must: false
        }]
      },
      professionals: null,
      currentprofession: null,
      changekey: ''
    }
  },
  // computed: {
  //   forms() {
  //     return this.majorforms[this.currentcls]
  //   }
  // },
  watch: {
    status() {
      this.request()
    },
    currentcls(newValue, oldValue) {
      console.log(newValue, oldValue)
      if (newValue === oldValue) {
        return
      } else {
        this.forms = this.majorforms[this.currentcls]
      }
    }
  },
  created() {
    this.request()
    this.userInfo = userdata.getUserData()
  },
  methods: {
    async request() {
      if (this.status === '0') {
        const result = await api.personinfo()
        let u = null
        if (result.data) {
          u = result.data
        } else {
          console.error(result)
        }

        const sexresult = await comapi.listmenu({ code: 'sex' })
        if (sexresult.data) {
          const { data } = sexresult
          if (data.length) {
            this.sexlist = data[0].children
          }
        } else {
          console.error(sexresult)
        }

        for (let i = 0; i < this.sexlist.length; i++) {
          const sex = this.sexlist[i]
          if (u.sex === sex.dictKey) {
            this.sexKey = sex.dictKey
            break
          }
        }
        this.user = u
      } else if (this.status === '2') {
        const menulist = await comapi.listmenu({ code: 'identity_type' })
        if (menulist.data) {
          const { data } = menulist
          if (data.length) {
            this.majoroptions = data[0].children
          }
        }

        const perfesstional = await comapi.listmenu({ code: 'professional_title' })
        if (perfesstional.data) {
          const { data } = perfesstional
          if (data.length) {
            this.professionals = data[0].children
          }
        }
        console.log(this.professionals)

        const result = await api.personschollinfo()
        if (result.data) {
          const f = this.majoroptions.filter(item => {
            return parseInt(item.dictKey) === parseInt(result.data.schoolIdentity)
          })
          if (f.length) {
            this.currentmajor = f[0].dictKey
            this.majortoCls(this.currentmajor)
          } else {
            this.currentmajor = 2
            this.majortoCls(this.currentmajor)
          }
          this.currentprofession = result.data.schoolTitle
          this.school = result.data
        }
      } else {
        // api.teamuserinfo().then(r => {
        //   console.log(r)
        // }).catch(err => {
        //   console.error(err)
        // })
      }
    },
    requestSave() {
      if (this.status === '0') {
        if (!this.user.name || this.user.name === '') {
          this.$message({
            showClose: false,
            message: '请填写昵称',
            type: 'error'
          })
          return
        }
        const params = {
          id: this.user.id,
          tenantId: this.$store.getters.tenantId,
          name: this.user.name,
          realName: this.user.realName,
          sex: this.sexKey,
          bornDay: this.user.bornDay
        }

        const that = this
        api.savepersoninfo(params).then(r => {
          that.$message({
            showClose: false,
            message: '用户信息保存成功',
            type: 'success'
          })
          that.$emit('update')
        }).catch(err => {
          that.$message({
            showClose: false,
            message: err.message,
            type: 'error'
          })
        })
      } else if (this.status === '2') {
        // if (!this.school.schoolName || this.school.schoolName === '') {
        //   this.$message({
        //     showClose: false,
        //     message: '请填写所在学校',
        //     type: 'error'
        //   })
        //   return
        // }
        const params = {
          schoolIdentity: this.currentmajor,
          schoolName: this.school.schoolName,
          schoolAddTime: this.school.schoolAddTime,
          schoolDeptName: this.school.schoolDeptName,
          schoolDepartment: this.school.schoolDepartment,
          schoolMajor: this.school.schoolMajor,
          schoolClass: this.school.schoolClass,
          schoolWorkTime: this.school.schoolWorkTime,
          schoolTitle: this.currentprofession,
          schoolLeaveTime: this.school.schoolLeaveTime,
          schoolTutor: this.school.schoolTutor
        }
        const that = this
        api.personschollinfoupdate(params).then(r => {
          console.log(r)
          that.$message({
            showClose: false,
            message: '用户信息保存成功',
            type: 'success'
          })
        }).catch(err => {
          that.$message({
            showClose: false,
            message: err.message,
            type: 'error'
          })
        })
      } else if (this.status === '1') {
        this.$refs.cropperimg.uploadImg()
      }
    },
    uploadSuccess(v) {
      const params = {
        id: this.user.id,
        tenantId:this.$store.getters.tenantId,
        name: this.user.name,
        realName: this.user.realName,
        sex: this.sexKey,
        bornDay: this.user.bornDay,
        avatar: v.data
      }
      const that = this
      const userData = userdata.getUserData()
      api.savepersoninfo(params).then(r => {
        that.$message({
          showClose: false,
          message: '头像保存成功',
          type: 'success'
        })
        userData.avatar = v.data
        userdata.save()
        that.$emit('update')
      }).catch(err => {
        that.$message({
          showClose: false,
          message: err.message,
          type: 'error'
        })
      })
    },
    inputChange(e) {
      const typ = e.currentTarget.dataset.typ
      console.log(typ)
      if (typ === 'self_name') {
        this.user.name = e.target.value
      } else if (typ === 'self_realname') {
        this.user.realName = e.target.value
      }
    },
    datechange(e) {
      if (this.status === '0') {
        this.user[this.changekey] = e || ''
        this.changekey = ''
      } else if (this.status === '2') {
        this.school[this.changekey] = e || ''
        this.changekey = ''
      }
    },
    datefocus(e) {
      this.changekey = e.name
    },
    majorselectchange(e) {
      this.majortoCls(e)
    },
    majortoCls(v) {
      if (v === 1 || v === 2) {
        this.currentcls = 'junior'
      } else if (v === 3 || v === 4 || v === 5) {
        this.currentcls = 'master'
      } else if (v === 6) {
        this.currentcls = 'classmate'
      } else if (v === 7) {
        this.currentcls = 'teacher'
      }
    },
    bindWx() {
      const jsonstr = JSON.stringify({ u: 'bind', tid: 'ADKS' })
      const auth_url = `https://open.weixin.qq.com/connect/qrconnect?appid=wx2d0f0d039e76cf15&scope=snsapi_login&state=${Base64.encode(jsonstr)}&redirect_uri=${config.profile.pcHost}/#/`
      window.location.replace(auth_url)
    },
    toAuth() {
      const that = this
      this.$router.push({
        path: '/auth',
        query: {
          r: decodeURIComponent(that.$router.history.current.fullPath)
        }
      })
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
    color: #264480 !important;
    padding: 0 !important;
    border: none !important;
    height: 36px;
}
::v-deep .el-input__suffix-inner {
  display: none;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-input__prefix {
  left: 0;
}
::v-deep .el-input__icon {
  width: initial !important;
}

/deep/ .el-select-dropdown__item.selected {
  color: #264480 !important;
}

</style>
<style scoped>

.body-right-set-tip {
  background-color: #FFFAEF;
  height: 40px;
  margin-top: 20px;
  padding: 0 20px;

}

.body-right-set-tip p {
  color: #B29453;
}

.body-right-set-tip p:last-child {
  padding: 6px;
}

.body-right-set-form {
  margin-top: 20px;
  border: 1px solid #F3F4F9;
}

.body-right-set-form-item {
  margin-bottom: 30px;
}

.body-right-set-form-item:last-child {
  margin: 0;
}

.body-right-set-form-item-key {
  justify-content: flex-end;
  width: 134px;
  height: 40px;
  padding-right: 16px;
}

.body-right-set-form-item-value {
  width: 340px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #DEE0E7;
  /* overflow: hidden; */
}

.body-right-set-form-item-btn {
  width: 82px;
  height: 40px;
}

.body-right-set-form-item-value input {
  border: none;
  width: 100%;
}

.body-right-set-form-item-key-must {
  margin-right: 4px;
}

.body-right-set-form-item-value input:focus {
  outline: none;
}

 .body-right-set-form-item-value input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #DEE0E7;
  }
  .body-right-set-form-item-value input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #DEE0E7;
  }
  .body-right-set-form-item-value input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #DEE0E7;
  }
  .body-right-set-form-item-valueinput:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #26272b;
  }

  .body-right-set-form-item-valueinput:focus {
    outline: none;
  }

  .body-right-set-form-item .input-disabel {
    background-color: #E9E9F3;;
  }

  .body-right-set-form-item-des {
    height: 40px;
    margin-left: 10px;
  }

  .body-right-set-action {
    height: 126px;
  }

  .body-right-set-action-btns-cancel{
    width: 82px;
    height: 30px;
    background-color: #F3F4F9;
  }

  .body-right-set-action-btns-save {
    width: 82px;
    height: 30px;
    margin-left: 36px;
  }

  .input-date-hidden {
    width: 100%;
    height: 80%;
    left: 0;
    right: 0;
    z-index: 9;
    opacity: 0;
  }
  .body-right-set-form-item-value-cropper {
    width: 100%;
    margin-left: 8px;
  }

  .body-right-set-form-padding {
    padding: 48px 0;
    border-bottom: 1px solid #F3F4F9;
  }

  .end-arrow {
    right: 14px;
    pointer-events: none;
  }

  .end-arrow-transform {
    transform: rotate(180deg);
  }

</style>
